export function isAdminRole(role: string | null | undefined): boolean {
  const r = (role || "").replace(/^org:/, "");
  return r === "admin" || r === "owner";
}

export function roleLabel(role: string | null | undefined): string {
  return (role || "member").replace(/^org:/, "");
}
